// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"4cc931cc","162":"bb6fb04d","474":"232a87bb","585":"30e3db83","605":"d7f30215","611":"e88be7ca","852":"899816e3","928":"7994fc00"}[chunkId] + ".css";
};